import { FC } from 'react';
import { Outlet, Route, Routes } from 'react-router';
import { useWorkstation } from '@connect-x-app/hybrid-state';
import { Profile } from '@connect-x-app/web-feature-app-config';
import { ChannelLayout, ChatWrapper } from '@connect-x-app/web-feature-channel';
import { NotificationCenter } from '@connect-x-app/web-feature-notification';
import { useApp } from '@connect-x-app/web-state';
import { SHELL_TEST_IDS } from '@connect-x-app/web-test-ids';
import classNames from 'classnames';

import './DashboardLayout.scss';

export const DashboardLayout: FC = () => {
  const { isNotificationCenterVisible, isProfileVisible, setIsNotificationCenterVisible, setIsProfileVisible } = useApp();
  const { isWorkstationOpen } = useWorkstation();

  return (
    <>
      <main className="dashboard-layout">
        <Outlet />
        <div
          className={classNames({
            'dashboard-layout__chat-wrapper--hidden': isWorkstationOpen,
          })}
          data-test={SHELL_TEST_IDS.dashboard.routes}
        >
          <Routes>
            <Route element={<ChannelLayout />}>
              <Route element={<ChatWrapper />} path="*" />
            </Route>
          </Routes>
        </div>
      </main>
      <NotificationCenter isVisible={isNotificationCenterVisible} onClose={() => setIsNotificationCenterVisible(false)} />
      <Profile isVisible={isProfileVisible} onClose={() => setIsProfileVisible(false)} />
    </>
  );
};
